var _g, _path, _g2, _path2, _g3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiddle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 161,
    viewBox: "0 0 124 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3482_6649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 38.8008L70 10.8008V68.8008L15 96.8008L15 38.8008Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M15 38.8008L70 10.8008V68.8008L15 96.8008L15 38.8008Z",
    fill: "#A0A0A0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3482_6649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7 61L89.7 33V91L34.7 119L34.7 61Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M34.7 61L89.7 33V91L34.7 119L34.7 61Z",
    fill: "#EC691A"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3482_6649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 83L109 55V113L54 141L54 83Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M54 83L109 55V113L54 141L54 83Z",
    fill: "#A0A0A0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8885 105.385L15 115.897L34.8885 137.618L53.9766 140.098M87 124L83.9 144L56.3242 140.414",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M53.96 140.102L56.336 140.417",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7 144L83.8 126.5M15 115.897V38.8512M34.8885 137.618V61.5M89.5001 33L83.8759 67.8019L34.8885 61.5M89.5001 33L69.9696 11M89.5001 33L109 55M89.5001 33V65.6997M34.8885 61.5L15 38.8512M34.8885 61.5L54.0001 83.5M69.9696 11L15 38.8512M69.9696 11L70 43.0542",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M70 43V88",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M89.5 65.5V107",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M83.8 67.9004V126.7",
    stroke: "#7B7B7B",
    strokeWidth: 0.5,
    strokeDasharray: "2 2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M87.0835 123.862L89.5 106.954L69.9695 88L34.7291 105.486",
    stroke: "#7B7B7B",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3482_6649",
    x: 0,
    y: 0.800781,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3482_6649",
    x: 19.7,
    y: 23,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6649",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3482_6649",
    x: 39,
    y: 45,
    width: 85,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3482_6649"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3482_6649",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddle);
export default __webpack_public_path__ + "static/media/Middle.a5942c7ed6210a964dad2679d9597458.svg";
export { ForwardRef as ReactComponent };